import { FileSpreadsheet, FileText } from 'lucide-react';
import { Button } from '@/shared/ui/button/Button';
import type { PnLReportData } from './types';
import { exportPnLToExcel } from './excelExport';
import { exportPnLToPdf } from './pdfExport';

export function PnLReportActions({
  data,
  disabled,
}: {
  data: PnLReportData;
  disabled?: boolean;
}) {
  return (
    <div className="flex items-center gap-2">
      <Button
        variant="outline"
        size="sm"
        disabled={disabled}
        onClick={() => exportPnLToExcel(data)}
        className="gap-1.5"
      >
        <FileSpreadsheet className="h-4 w-4" /> Excel
      </Button>
      <Button
        variant="outline"
        size="sm"
        disabled={disabled}
        onClick={() => exportPnLToPdf(data)}
        className="gap-1.5"
      >
        <FileText className="h-4 w-4" /> PDF
      </Button>
    </div>
  );
}
